import { actionTypes } from '../actions/intl';

export default function intl(state = null, action) {
  if (state === null) {
    return {
      initialNow: 0,
    };
  }

  switch (action.type) {
    case actionTypes.SET_LOCALE_START: {
      const locale = state[action.payload.locale] ? action.payload.locale : state.locale;
      return {
        ...state,
        locale,
        newLocale: action.payload.locale,
      };
    }

    case actionTypes.SET_LOCALE_SUCCESS: {
      return {
        ...state,
        locale: action.payload.locale,
        newLocale: null,
        messages: {
          ...state.messages,
          [action.payload.locale]: action.payload.messages,
        },
      };
    }

    case actionTypes.SET_LOCALE_ERROR: {
      return {
        ...state,
        newLocale: null,
      };
    }

    default: {
      return state;
    }
  }
}
